import WSInternalEvent from '../utils/helpers/ws-internal-event';

let injectedWindow;
let nativeAddEventListener;
let nativeRemoveEventListener;
let listeners = [];

const add = (liveElement, event, callback) => {
  if (callback && callback.name && callback.name.indexOf(WSInternalEvent.name) > -1) return;

  listeners.push({ liveElement, event, callback });
};

const remove = (liveElement, event, callback) => {
  // Create new array which does not contain target listener
  listeners = listeners.filter((listener) => {
    const isSameElement = listener.liveElement === liveElement;
    const isSameEvent = listener.event === event;
    const isSameCallback = listener.callback === callback;

    return !isSameElement || !isSameEvent || !isSameCallback;
  });
};

const hasFor = (liveElement) => listeners.some((listener) => listener.liveElement === liveElement);

const getAll = () => listeners;

const watch = (liveWindow) => {
  injectedWindow = liveWindow;
  nativeAddEventListener = injectedWindow.Element.prototype.addEventListener;
  nativeRemoveEventListener = injectedWindow.Element.prototype.removeEventListener;

  function iAddEventListener(event, callback) {
    add(this, event, callback);
    return nativeAddEventListener.apply(this, arguments);
  }

  function iRemoveEventListener(event, callback) {
    remove(this, event, callback);
    return nativeRemoveEventListener.apply(this, arguments);
  }

  injectedWindow.Element.prototype.addEventListener = iAddEventListener;
  injectedWindow.Element.prototype.removeEventListener = iRemoveEventListener;
};

const reset = () => {
  if (injectedWindow) {
    injectedWindow.Element.prototype.addEventListener = nativeAddEventListener;
    injectedWindow.Element.prototype.removeEventListener = nativeRemoveEventListener;
  }

  listeners = [];
};

export default {
  add,
  remove,
  getAll,
  hasFor,
  watch,
  reset,
};
